/**
 * Deterministic tag colors derived from the tag name. Mirrors the PHP
 * implementation in src/Support/TagColor.php - keep both in sync.
 *
 * Hashing iterates UTF-8 bytes (TextEncoder) so the colors match the byte
 * based PHP implementation for non-ASCII tag names as well.
 */
export const tagColors = {
  bgColorFromString: (string) => {
    if (string.length === 0) {
      return '#4f46e5'
    }

    let hash = 0
    for (const byte of new TextEncoder().encode(string)) {
      hash = byte + ((hash << 5) - hash)
      hash = hash & 0xffffffff
    }

    let color = '#'
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 255
      color += ('00' + value.toString(16)).slice(-2)
    }

    return color
  },

  textColorForBackground: (string) => {
    string = string.replace('#', '')
    const r = parseInt(string.substring(0, 2), 16)
    const g = parseInt(string.substring(2, 4), 16)
    const b = parseInt(string.substring(4, 6), 16)

    const brightness = (r * 299 + g * 587 + b * 114) / 1000

    return brightness >= 140 ? '#000000' : '#ffffff'
  },
}
